import { getNavbarAppHref } from '../../../components/navbar/Navbar'
import { useSafeApiOrgSlug } from '../../../utils/orgSlug'

export function useAnnouncementsPath() {
  const orgSlug = useSafeApiOrgSlug()
  if (orgSlug === null) {
    return null
  }

  return getNavbarAppHref({
    app: 'app',
    path: `/${orgSlug}/announcements`,
  })
}
